import React from 'react';
import { useQuery } from '@apollo/client';
import { motion } from 'framer-motion';
import { GLOBAL_QUERY } from '@/queries/queries';
import DynamicLogo from './DynamicLogo';

// Types for rich text content
interface RichTextChild {
  type: 'text' | 'link';
  text?: string;
  url?: string;
  children?: RichTextChild[];
}

interface RichTextBlock {
  children: RichTextChild[];
}

interface AboutTBC {
  address?: string;
  title?: string;
  description?: RichTextBlock[];
  logo?: any;
}

interface GlobalData {
  global: {
    footer: {
      about_tbc: AboutTBC;
      top_left_side_text?: string;
    };
  };
}

interface LogoProps {
  width?: number;
  height?: number;
  fillColor?: string;
  textColor?: string;
}

export const LogoInfo: React.FC<LogoProps> = ({ fillColor = '#9E703E' }) => {
  const { data } = useQuery<GlobalData>(GLOBAL_QUERY);

  const about = data?.global?.footer?.about_tbc?.logo?.url;

  return (
    <motion.div
      className="flex flex-col items-center justify-center w-full mt-16 about_tbc relative z-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.3 }}
    >
      {about && <DynamicLogo svgUrl={about} color={fillColor} />}
    </motion.div>
  );
};

export default LogoInfo;
